module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "roxanne-samuels.96330693.png";